import PropTypes from "prop-types";

export const yardLink = PropTypes.shape({
  path: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
});
